export const ItemTypes = {
  SECTION: 'section',
  ELEMENT: 'element',
  PATH_STEP: 'pathStep',
  ADDER: 'adder',
  INTERACTION: 'interaction',
};
